$(function() {   // Run page
  let popup = $('.popup-redir');
  let shippingCountry = localStorage.getItem("shippingCountry");
  
  let urlParam = window.location.search;
  if(popup.hasClass('deactive')) {
    
  } else if(~urlParam.indexOf('redirect=true')) {
    localStorage.setItem("shippingCountry", "UK");
  } else if(shippingCountry != "UK" || popup.hasClass('test-mode')) {
    $('.popup-redir').fadeIn(500);
  }
  
  let countrySelection = '<div class="pick-country"><select class="select-shipping-country"><option value="#">UK</option><option value="https://lawsonjewelry.com/?redirect=true">Intl</option></select><i class="fa fa-angle-down mldarrow"></i></div>';
  if($(window).width() >= 730) {
    let parentElem = $('.site-logo_row .logo_row_relative');
    parentElem.append(countrySelection);
  } else {
    parentElem = $('.mobile_menu_items_scroll_padd');
    parentElem.append(countrySelection);
    parentElem.find('select option').each(function() {
      let optionText = $(this).text();
      if(~optionText.indexOf('Intl')) $(this).text('International');
      else if(~optionText.indexOf('UK')) $(this).text('United Kingdom');
    });
    let currencyEl = $('.main_menuMobile_all .search_mobile_Drawer .header_currencies');
    if(currencyEl) {
      parentElem.append(currencyEl);
    }
  }

  $('body').on('click', '.pick-country', function() {
    $('.popup-redir').fadeIn(500);
  });
  $('body').on('change', '.pick-country .select-shipping-country', function() {
    if($(this).val() != '#') window.location.href = $(this).val();
  });

  /*
  $('body').on('click', '.pick_currency .nice-select ul.list li', function(e) {
    let value = $(this).data('value');
    if(e.clientX && value == 'GBP') {
      $('.popup-redir .inner .country-choose select').val('https://lawsonjewelry.com/?redirect=true');
      $('.popup-redir').fadeIn(500);
    }
  });
  */
});

$('.popup-redir .inner .close').on('click', function() {  // Close button
  localStorage.setItem("shippingCountry", "UK");
  $(this).closest('.popup-redir').fadeOut(500);
});

$('.popup-redir .inner .country-choose .link a, .popup-redir .inner .countries a').on('click', function() {  // Choose country button
  if($(this).attr('href') == '#') {
    $(this).closest('.popup-redir').fadeOut(500);
    localStorage.setItem("shippingCountry", "UK");
  } else window.location.href = $(this).attr('href');
  return false;
});

$('.popup-redir .inner .country-choose select').on('change', function() {  // Select country
  let link = $(this).closest('.popup-redir').find('.country-choose .link a');
  link.attr('href', $(this).val());
});

$('.footer_items .item a').on('click', function() {   // Footer link
  let linkText = $(this).text();
  if(~linkText.indexOf('Change Region')) {
    $('.popup-redir').fadeIn(500);
    return false;
  }
});